<template>
  <!-- 招募司机 -->
  <div class="container container-tabs">
    <div class="handle-box-search">
      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">司机电子合同编码:</span>
          <el-input
            v-model="search_data.driver_contract_code"
            placeholder="司机电子合同编码"
            class="handle-input mr10"
            @keyup.enter.native="searchContractLists"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="title">司机姓名:</span>
          <el-input
            v-model="search_data.driver_name"
            placeholder="司机姓名"
            class="handle-input mr10"
            @keyup.enter.native="searchContractLists"
          ></el-input>
        </el-col>

        <el-col :span="8">
          <span class="title">司机电话:</span>
          <el-input
            v-model="search_data.driver_phone"
            placeholder="司机电话"
            class="handle-input mr10"
            maxlength="11"
            @keyup.enter.native="searchContractLists"
          ></el-input>
        </el-col>

        <el-col
          :span="8"
          style="margin-top: 10px"
        >
          <span class="title">电子合同编码:</span>
          <el-input
            v-model="search_data.contract_num"
            placeholder="电子合同编码"
            class="handle-input mr10"
            maxlength="11"
            @keyup.enter.native="searchContractLists"
          ></el-input>
        </el-col>

        <el-col
          :span="8"
          style="margin-top: 10px"
        >

          <span class="title">电子合同状态:</span>
          <el-select
            v-model="search_data.contract_status"
            placeholder="电子合同状态"
            style="width: 150px; margin-right: 20px"
            @keyup.enter.native="searchContractLists"
          >
            <el-option
              label="全部"
              value=""
            ></el-option>
            <el-option
              label="签署中"
              value="0"
            ></el-option>
            <el-option
              label="签署完成"
              value="1"
            ></el-option>
            <el-option
              label="拒绝签署"
              value="2"
            ></el-option>
            <el-option
              label="解除中"
              value="3"
            ></el-option>
            <el-option
              label="解除完成"
              value="4"
            ></el-option>
            <el-option
              label="拒绝解除"
              value="5"
            ></el-option>
            <el-option
              label="已撤回"
              value="6"
            ></el-option>
            <el-option
              label="已过期"
              value="7"
            ></el-option>
          </el-select>

        </el-col>
      </el-row>

      <div>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchContractLists"
        >搜索</el-button>
        <el-button
          icon="el-icon-refresh-right"
          @click="refresh"
        >刷新</el-button>
       
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <!-- <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                  <el-dropdown
                      split-button
                      type="primary"
                      @click="
                          edit_isShow = !edit_isShow;
                          editData = scope.row.id;
                      "
                      trigger="click"
                  >
                      修改备注

                      <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="del(scope.row.id)"> 删除 </el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
              </template>
          </el-table-column> -->

      <el-table-column
        prop="driver_contract_code"
        label="司机电子合同编码"
        width="180"
      > </el-table-column>
      <el-table-column
        prop="driver_name"
        label="司机姓名"
      > </el-table-column>
      <el-table-column
        prop="driver_phone"
        label="司机电话"
      > </el-table-column>

      <el-table-column
        prop="contract_num"
        label="电子合同编号"
        width="220"
      > </el-table-column>

      <el-table-column
        prop="contract_name"
        label="电子合同名称"
      > </el-table-column>

      <el-table-column
        prop="contract_status_text"
        label="电子合同状态"
      >

      </el-table-column>

      <el-table-column
        prop="remarks"
        label="备注"
      >
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="创建时间"
        width="150"
      > </el-table-column>

      <el-table-column
        label="操作"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            v-if="scope.row.contract_status>0"
            @click="
                          toContractDetail(scope.row.driver_contract_code)
                      "
            trigger="click"
          >
            详情

          </el-button>

          <el-button
            type="danger"
            v-if="scope.row.contract_status==1"
            @click.native="contractCancel(scope.row.driver_contract_code)"
          >
            解除
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages
        :search_data="search_data"
        :result_data="result_data"
        @pages_function="pages_function"
      ></pages>
    </div>

    <el-dialog
      :visible.sync="iframe_show"
      width="50%"
    >

      <iframe
        class=""
        :src="iframe_url"
        style="width: 100%;height: 60vh"
      ></iframe>
      <div style="text-align: center">
        <el-button
          @click="iframe_show = false"
          class="close-btn"
        >关闭</el-button>
      </div>
    </el-dialog>


    <el-dialog
      :visible.sync="cancelModel_show"
      width="300px"
    >

      <div style="display: flex; align-items: center;">
        原因:
        <el-input type="text" v-model="reason" style="width: 200px;margin-left: 10px;"></el-input>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button
        type="primary"
          @click="cancelSubmit"
          class="close-btn"
        >确认</el-button>
        <el-button
          @click="cancelModel_show = false"
          class="close-btn"
        >关闭</el-button>
      </div>
    </el-dialog>



    <!-- 司机招募配置组件 -->
    <!-- <getDriverRecruitConf :isShow="recruit_isShow"></getDriverRecruitConf> -->

    <!-- 审核组件 -->
    <!-- <editdriverRecruit :isShow="edit_isShow" :data="editData" @onSubmit="recruitLists"> </editdriverRecruit> -->
  </div>
</template>

<script>
import axios from 'axios';
import { config } from '../../../../utils/config';

var _this;
// import editdriverRecruit from '../editdriverRecruit.vue';
// import getDriverRecruitConf from "./getDriverRecruitConf.vue";

export default {
    components: {
        // editdriverRecruit,
        // getDriverRecruitConf
    },
    data() {
        return {



            cancelModel_show:false,

            cancelModel_data:'',

            reason:'',

            // 存放表格数据
            tableData: [],

            iframe_show: false,
            iframe_url: '',

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                driver_contract_code: '',
                driver_name: '',
                driver_phone: '',
                contract_num: '',
                contract_status: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.contractList();
    },

    methods: {
      cancelSubmit(){
        if(this.reason == ''){
          this.$message.error('请填写原因');
          return;
        }
        this.$post('/contract/contractCancel', {
                driver_contract_code: this.cancelModel_data,
                reason:this.reason
            })
            .then((res) => {
              this.reason = '';
              this.$message.success('解除成功');
              this.cancelModel_show = false;
            })
            .catch((err) => {});
      },
        contractCancel(code) {
            this.cancelModel_show = true;
            this.cancelModel_data = code;
        },
        toContractDetail(code) {
            this.$post('/contract/contractDetail', {
                driver_contract_code: code
            })
                .then((res) => {
                    this.iframe_url = res.data.contract_file;

                    this.iframe_show = true;
                })
                .catch((err) => {});
        },

        // getCityList(){
        //
        //     _this.$nextTick(function() {
        //         axios.defaults.baseURL = config.axios_normalURL; //请求base url
        //
        //         _this.$post('/city/getCityLists')
        //             .then((res) => {
        //
        //                 _this.city_data = res.data;
        //
        //                 axios.defaults.baseURL = config.axios_baseURL; //请求base url
        //             })
        //             .catch((err) => {
        //             });
        //         axios.defaults.baseURL = config.axios_baseURL; //请求base url
        //     });
        //
        //
        // },

        searchContractLists() {
            _this.search_data.page = 1;
            _this.contractList();
        },

        // 搜索司机列表
        contractList() {
            _this
                .$post('/contract/contractList', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.list;
                    _this.result_data = res.data;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.contractList();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.title {
    width: 110px !important;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
